export enum SubscriptionType {
  WITH_PROLONGATION = 'WITH_PROLONGATION',
  WITHOUT_PROLONGATION = 'WITHOUT_PROLONGATION',
}
